import * as Gamee from "./Gamee";



export const enum eEvent {
    /**
     * Will be emitted when user start or restart the game.
     */
    start = "start",
    /**
     * Will be emitted when user paused the game.
     */
    pause = "pause",
    /**
     * Will be emitted after user resumes the game after pause or GameeApp suspension.

     */
    resume = "resume",
    /**
     * Will be emitted when user clicks the mute button and the game must mute all game sounds.
     */
    mute = "mute",
    /**
     * Will be emitted when user clicks the unmute button and the game should unmute all game sounds.
     */
    unmute = "unmute",
    /**
     * Revive player
     */
    useExtraLife = "useExtraLife",
    /**
     * Hrac ukoncil hru
     */
    submit = "submit"
}



export const enum eState {
    unitialized,
    /**
     * Probiha inicializace
     */
    waitForInit,
    /**
     * Probehla uspesne inicializace, ale nebylo zavolano gamee.gameReady()
     */
    initialized,
    /**
     * Probiha cekani na "start" udalost od GAMEE
     */
    waitForStart,
    /**
     * Byla prijata "start" udalost od GAMEE
     */
    started,
    /**
     * 
     */
    gameOver,
}



export const enum eAdState {
    ready,
    loading,
    showing,
    uninitialized,
}



export class Wrapper {
    private static readonly _ERROR_GAMEE_DOESNT_EXIST = "GAMEE doesn't exist.";
    private static readonly _ERROR_DUPLICATE_CALL = "Duplicate call: ";
    private static readonly _ERROR_NOT_INITIALIZED = "GAMEE is not yet initialized.";

    /**
     * GAMEE API
     */
    static GAMEE: Gamee.IGamee;

    /**
     * (RO) Aktualni stav
     */
    static get GAMEE_STATE(): eState { return Wrapper._GAMEE_STATE; }
    private static _GAMEE_STATE: eState = eState.unitialized;

    /**
     * Init Data
     */
    static INIT_DATA: Gamee.IGameInitData;

    /**
     * (RO) Spravce udalosti
     */
    static get EVENTS(): pc.EventHandler { return Wrapper._EVENTS; }
    private static _EVENTS: pc.EventHandler = new pc.EventHandler();

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static gameInit(caps: Gamee.eCapability[], clb: () => void, clbCtx: any): void {
        if (Wrapper._GAMEE_STATE != eState.unitialized)
            throw new Error(Wrapper._ERROR_DUPLICATE_CALL + "gamee.gameInit()");

        Wrapper.GAMEE = (<any>window).gamee;

        if (!Wrapper.GAMEE) {
            console.log(Wrapper._ERROR_GAMEE_DOESNT_EXIST);

            Wrapper._GAMEE_STATE = eState.initialized;
            clb.call(clbCtx);

            return;
        }

        Wrapper._GAMEE_STATE = eState.waitForInit;

        Wrapper.GAMEE.gameInit("FullScreen", {}, caps, (error: string, data: Gamee.IGameInitData): void => {
            if (error)
                throw new Error(error);

            Wrapper._GAMEE_STATE = eState.initialized;

            // Ulozit initData
            Wrapper.INIT_DATA = data;

            // Zachytavani GAMEE udalosti
            Wrapper.GAMEE.emitter.addEventListener("start", () => {
                Wrapper._GAMEE_STATE = eState.started;
                Wrapper._EVENTS.fire(eEvent.start);
            });

            Wrapper.GAMEE.emitter.addEventListener("pause", () => {
                Wrapper._EVENTS.fire(eEvent.pause);
            });

            Wrapper.GAMEE.emitter.addEventListener("resume", () => {
                Wrapper._EVENTS.fire(eEvent.resume);
            });

            Wrapper.GAMEE.emitter.addEventListener("mute", () => {
                Wrapper._EVENTS.fire(eEvent.mute);
            });

            Wrapper.GAMEE.emitter.addEventListener("unmute", () => {
                Wrapper._EVENTS.fire(eEvent.unmute);
            });

            Wrapper.GAMEE.emitter.addEventListener("useExtraLife", () => {
                Wrapper._GAMEE_STATE = eState.started;
                Wrapper._EVENTS.fire(eEvent.useExtraLife);
            });

            Wrapper.GAMEE.emitter.addEventListener("submit", () => {
                Wrapper._EVENTS.fire(eEvent.submit);
            });

            // Callback
            clb.call(clbCtx);
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static gameReady(): void {
        if (Wrapper._GAMEE_STATE == eState.initialized) {
            if (Wrapper.GAMEE) {
                Wrapper._GAMEE_STATE = eState.waitForStart;
                Wrapper.GAMEE.gameReady((error: string): void => {
                    if (error)
                        throw new Error(error);
                });
            }
            else {
                Wrapper._GAMEE_STATE = eState.started;
                Wrapper._EVENTS.fire(eEvent.start);
            }
        }
        else if (Wrapper._GAMEE_STATE < eState.initialized) {
            throw new Error(Wrapper._ERROR_NOT_INITIALIZED);
        }
        else {
            throw new Error(Wrapper._ERROR_DUPLICATE_CALL);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static gameStart(): void {
        if (Wrapper.GAMEE && Wrapper._GAMEE_STATE == eState.started)
            Wrapper.GAMEE.gameStart();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static gameSave(saveState: any): void {
        if (Wrapper.GAMEE)
            Wrapper.GAMEE.gameSave(typeof saveState == "string" ? saveState : JSON.stringify(saveState));
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static gameOver(replay?: string): void {
        if (Wrapper._GAMEE_STATE == eState.started) {
            Wrapper._GAMEE_STATE = eState.gameOver;

            if (Wrapper.GAMEE) {
                Wrapper.GAMEE.gameOver(replay);
            }
            else {
                Wrapper._GAMEE_STATE = eState.started;
                Wrapper._EVENTS.fire(eEvent.start);
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static updateScore(score: number, timeMs?: number, hash?: string): void {
        if (Wrapper.GAMEE)
            Wrapper.GAMEE.updateScore(score, timeMs, hash);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static logEvent(name: string, value: string): void {
        if (Wrapper.GAMEE && Wrapper._GAMEE_STATE >= eState.initialized) {
            Wrapper.GAMEE.logEvent(name, value);
        }
        else {
            console.log("EVENT: " + name + " - " + value);
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Updates the mission progress on the platform level, making it visible for the player after the game over. Should be called with every mission progress change.
     * @param progress Progress of a specific mission, number in <0, 100> range
     */
    //-------------------------------------------------------------------------
    static updateMissionProgress(progress: number): void {
        if (progress > 100)
            progress = 100;

        if (Wrapper._GAMEE_STATE >= eState.initialized && Wrapper.GAMEE) {
            Wrapper.GAMEE.updateMissionProgress(progress);
        }
    }

    //*************************************************************************
    //*************************************************************************
    // Reklamy
    //*************************************************************************
    //*************************************************************************

    /**
     * (RO) Aktualni stav reklamy
     */
    static get adState(): eAdState { return Wrapper._adState; }
    private static _adState: eAdState = eAdState.uninitialized;

    /**
     * (RO) True, pokud je reklama pripravena k zobrazeni
     */
    static get adReady(): boolean { return Wrapper._adState == eAdState.ready; }

    //-------------------------------------------------------------------------
    /**
     * Nacteni reklamy. Po dokonceni se vola callback, kteremu se predaji nasledujici parametry:
     * res: boolean True, pokud se reklamu podarilo nacist a je pripravena pro zobrazeni
     * @returns True, pokud bylo nacteni reklamy zahajeno.
     */
    //-------------------------------------------------------------------------
    static loadAd(cbFnc?: (res: boolean) => void, cbCtx?: any): boolean {
        if (Wrapper.GAMEE) {
            if (Wrapper._GAMEE_STATE < eState.initialized || Wrapper._adState != eAdState.uninitialized)
                return false;

            Wrapper._adState = eAdState.loading;

            try {
                Wrapper.GAMEE.loadRewardedVideo((error: string, data: { videoLoaded: boolean }) => {
                    Wrapper._adState = (data && data.videoLoaded ? eAdState.ready : eAdState.uninitialized);

                    if (cbFnc)
                        cbFnc.call(cbCtx, Wrapper._adState == eAdState.ready);
                });
            }
            catch (e) {
                return false;
            }
        }
        else {
            Wrapper._adState = eAdState.ready;
        }

        return true;
    }

    //-------------------------------------------------------------------------
    /**
     * Zobrazeni reklamy. Reklama musi byt ve stavu eAdState.ready. Po dokonceni zobrazeni reklamy se vola callback, kteremu se predaji nasledujici parametry:
     * res: boolean True, pokud reklama byla zobrazena
     * @returns True, pokud bylo zobrazeni reklamy zahajeno
     */
    //-------------------------------------------------------------------------
    static showAd(cbFnc: (res: boolean) => void, cbCtx: any): boolean {
        if (Wrapper.GAMEE) {
            // Overit zda je reklama nactena
            if (Wrapper._adState != eAdState.ready) {
                // Pokusit se nacist reklamu
                return Wrapper.loadAd((res: boolean): void => {
                    if (res) {
                        // Zobrazit reklamu
                        Wrapper.showAd(cbFnc, cbCtx);
                    }
                    else {
                        // Reklamu se nepodarilo nacist
                        cbFnc.call(cbCtx, false);
                    }
                });
            }

            Wrapper._adState = eAdState.showing;

            Wrapper.GAMEE.showRewardedVideo(function (error: string, data: { videoPlayed: boolean }) {
                Wrapper._adState = eAdState.uninitialized;
                cbFnc.call(cbCtx, (data && data.videoPlayed));
            });
        }
        else {
            cbFnc.call(cbCtx, true);
        }

        return true;
    }
}